import { render, staticRenderFns } from "./UnitsOfMeasureForm.vue?vue&type=template&id=6dc11c7c"
import script from "./UnitsOfMeasureForm.vue?vue&type=script&lang=js"
export * from "./UnitsOfMeasureForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports